// extracted by mini-css-extract-plugin
export default {"errors":"styles__errors__f15838c3225003b075fd"};